/** Appeal workflow status values for case appeals. */
export enum AppealStatus {
  DONE = "done",
  PENDING = "pending",
  IN_PROGRESS = "in_progress",
  NOT_STARTED = "not_started",
}

/** Human-readable labels for {@link AppealStatus} values. */
export const AppealStatusLabels: Record<AppealStatus, string> = {
  [AppealStatus.DONE]: "Done",
  [AppealStatus.PENDING]: "Pending",
  [AppealStatus.IN_PROGRESS]: "In Progress",
  [AppealStatus.NOT_STARTED]: "Not Started",
};
